const ReloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Page-1" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g id="Reload">
        <path id="Rectangle" fillRule="nonzero" d="M0 0h24v24H0z"></path>
        <path
          id="Path"
          stroke="#0C0310"
          strokeLinecap="round"
          strokeWidth="2"
          d="M4 13a8 8 0 1 0 3.755-6.782"
        ></path>
        <path
          id="Path"
          stroke="#0C0310"
          strokeLinecap="round"
          strokeWidth="2"
          d="m9.238 1.898-1.74 3.941a1 1 0 0 0 .512 1.319l3.94 1.74"
        ></path>
      </g>
    </g>
  </svg>
);

export default ReloadIcon;